export abstract class AppError extends Error {
  public readonly customError = true

  constructor(
    name: string,
    message: string,
    public readonly title?: string,
    public readonly statusCode?: number
  ) {
    super(message)
    this.name = name
    Object.setPrototypeOf(this, new.target.prototype)
  }
}

// Declarada aqui (e não em arquivo próprio) porque src/domain/ é frozen
// e não aceita novos arquivos — ver .gemini/styleguide.md.
export class TooManyRequestsError extends AppError {
  private static NAME: string = 'TooManyRequestsError'
  public static MESSAGE: string =
    'Muitas tentativas em sequência. Aguarde alguns minutos e tente novamente.'

  constructor(message?: string | null, title?: string | undefined) {
    super(TooManyRequestsError.NAME, message ?? TooManyRequestsError.MESSAGE, title)
  }
}
